import React from 'react'
import './ContactButton.css'

function ContactButton() {
    return(
        <div >
            <button className='Btn center'>Contact Us</button>
        </div>
    )
}

export default ContactButton